window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},

	updateTotals: function () {
		let $form = $("#form-cart-order");
		let params = $form.serializeArray();

		$.get('/cart/get_totals', params, function (data) {
			let $totals = $(".catalog-cart--total");
			let cntTotals = 0;

			let $sumProducts = $totals.find('[data-sum="products"]');
			if (typeof data.sums.sum_products !== 'undefined') {
				cntTotals++;
				$sumProducts.find('[data-sum-value]').html(output_roubles(data.sums.sum_products));;
			}

			let $sumPromocode = $totals.find('[data-sum="promocode"]');
			let $sumPromocodeValue = $sumPromocode.find('[data-sum-value]');
			if (typeof data.sums.sum_promocode !== 'undefined' && data.sums.sum_promocode > 0) {
				cntTotals++;
				$sumPromocodeValue.html(output_roubles(-data.sums.sum_promocode))
				$sumPromocode.removeClass('d-none');
			} else {
				$sumPromocode.addClass('d-none');
			}

			let $sumTotal = $totals.find('[data-sum="total"]');
			let $sumTotalValue = $sumTotal.find('[data-sum-value]');
			if (typeof data.sums.sum !== 'undefined') {
				$sumTotalValue.html(output_roubles(data.sums.sum));
			}

			if (cntTotals > 1) {
				$sumProducts.removeClass('total');
				$sumTotal.removeClass('d-none');
			} else {
				$sumProducts.addClass('total');
				$sumTotal.addClass('d-none');
			}
		});
	}
};

require('./_order_promocode')

$(document).ready(function () {
	let $formOrder = $("#form-cart-order");

	// VegasCatalog.Order.Courier.init();

	let $deliveries = $formOrder.find('[name=delivery_id]');
	$deliveries.on('change', function () {
		let id = $(this).attr('id'),
			$containerOrder = $(this).closest('#form-cart-order'),
			$containerDelivery = $containerOrder.find('.delivery-area--placement');

		// set show & active
		$containerDelivery.find('.active').removeClass('show active');
		let $currentDelivery = $containerDelivery.find('[data-id=' + id + ']');
		$currentDelivery.addClass('show active');

		// use required
		$('.delivery-area--placement .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');

		VegasCatalog.Cart.updateTotalAll();

		let payids = String($(this).data('payids')).split(',');
		$formOrder.find('[name=payment_id]').each(function (i, e) {
			let id = String($(e).val());
			if (payids.indexOf(id) !== -1) {
				$(e).attr('disabled', false);
			} else {
				$(e).attr('disabled', true);
			}
		});

		let $activePay = $formOrder.find('[name=payment_id]:checked');
		if ($activePay.is(':disabled')) {
			let $notDisabledPay = $formOrder.find('[name=payment_id]:not(:disabled)').first();
			$notDisabledPay.prop('checked', true).trigger('change');
		}
	});

	let $activeDelivery = $deliveries.filter(':checked');
	if ($activeDelivery.is(':disabled')) {
		$deliveries.filter(':not(:disabled)').first().trigger('change');
	} else {
		$activeDelivery.trigger('change');
	}

	$formOrder.submit(function () {
		$('.catalog-cart--preload').addClass('show');

		VegasCatalog.Order.make($formOrder, function (data) {
			if (data.error) {
				$('.catalog-cart--preload').removeClass('show')
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formOrder.on("keydown", function (event) {
		return event.key !== "Enter";
	});

	$formOrder.find('.to-time').change(function () {
		if ($(this).is(':checked')) {
			$(this).closest('.radio-button').find('.vg-select').removeClass('d-none');
		} else {
			$(this).closest('.radio-button').find('.vg-select').addClass('d-none');
		}
	});

	$formOrder.find('.soon-possible').change(function () {
		if ($(this).is(':checked')) {
			$(this).closest('.radio-button').find('.vg-select').addClass('d-none');
		} else {
			$(this).closest('.radio-button').find('.vg-select').removeClass('d-none');
		}
	});
});
